// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1z4pp","hiddenElements":"Header_hiddenElements__22JjS","search":"Header_search__Bjsm3","dark":"Header_dark__BdHfe","wrapper":"Header_wrapper__1mQtc"};